module.exports = __webpack_public_path__ + "static/media/shannonaviation.f1507912.png";